<template lang="pug">
.container-view
  ModalCadastroImcompleto
  AlterarSenha
  .label {{ nameRota }}
  router-view
</template>

<script>
import { mapMutations } from 'vuex'
import ModalCadastroImcompleto from '@/components/modais/CadastroIncompleto.vue'
import AlterarSenha from '@/components/modais/AlterarSenha.vue'

export default {
  name: 'ViewPage',

  components: {
    ModalCadastroImcompleto,
    AlterarSenha
  },

  // created(){
  //   if(localStorage.getItem('user') && JSON.parse(!localStorage.getItem('user').cadastro_finalizado))this.setCadastroImcompleto(true)
  // },

  computed: {
    nameRota() {
      return this.$route.name;
    }
  },

  methods: {
    ...mapMutations({
      setCadastroImcompleto: 'modais/setCadastroImcompleto'
    }),
  }
}
</script>

<style lang="scss">
.container-view{
  width: 100%;
  height: 100%;
  padding: 50px;
  box-sizing: border-box;
  overflow: auto;

  .label{
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 30px;
    color: #fff;
    position: relative;
    padding-left: 15px;

    &:before{
      content: "";
      width: 3px;
      height: 35px;
      background-color: #2788c7;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }

  
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #3e4095;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: #aaa;
    border-radius: 4px;
  }

  .sem-conteudo {
    color: #fff;
    margin-top: 50px;
    font-size: 20px;
    text-align: center;
    width: 100%;
  }
}


@media screen and (max-width: 768px){
  .container-view{
    padding: 30px 20px;

    .label{
      font-size: 20px;
      margin-bottom: 30px;
    }

    .sem-conteudo{
      margin-top: 10px;
      font-size: 12px;
    }
  }
}

.el-loading-mask{
  z-index: 99999 !important;
}
</style>